<template>
    <section>
         <v-layout row style="margin: 18px;">
            <support-dialog ref="TableData" :dialog='updateoption' @close='CloseDialog' @Update='CallUpdate'></support-dialog>
            <support-table @UPDATE='update' ref="UpdateTable"></support-table>
         </v-layout>
    </section>
</template>
<script>
import SupportDialog from '../views/dialogs/SupportDialog'
import SupportTable  from '../views/tables/SupportTable'
export default {
    components:{
        SupportTable,
        SupportDialog
    },
    data(){
        return {
            updateoption : false
        }
    },
    methods:{
        update(data){

            this.$refs.TableData.GetTicketDetails(data)
            this.updateoption = true
        },
        CloseDialog(){
            this.updateoption = false
        },
        CallUpdate(data){
            this.$refs.UpdateTable.UpdateTable(data)
            this.updateoption = false
        }   
    },
    mounted(){
        this.$eventHub.$emit("LOADING",'false')
    }
}
</script>
<style>

</style>